import(/* webpackMode: "eager" */ "/vercel/path0/examples/next/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/examples/next/src/components/providers/index.tsx");
